import { Button, Flex, Text } from "@chakra-ui/react"
import { EntityId } from "@jackfruit/common"
import React from "react"
import { useTranslation } from "react-i18next"

interface Props {
  selectedImageIds: EntityId[]
  isImportingImages: boolean
  hasSelectedImages: boolean
  handleUploadImages: () => void
}

const CloudImageBrowserActionsMobile: React.FC<Props> = ({
  selectedImageIds,
  handleUploadImages,
  hasSelectedImages,
  isImportingImages,
}) => {
  const { t } = useTranslation()

  return (
    <Flex px={4} py={4} justifyContent="space-between" alignItems="center">
      <Text>
        {t(
          "components.cloudProvider.common.browser.CloudImageBrowserActionsMobile.Selected",
          { count: selectedImageIds.length }
        )}
      </Text>
      <Flex gap={4}>
        <Button
          className="google-photos-import-images-button"
          colorScheme="primary"
          onClick={handleUploadImages}
          isLoading={isImportingImages}
          isDisabled={!hasSelectedImages}
        >
          {t(
            "components.cloudProvider.common.browser.CloudImageBrowserActionsMobile.Import"
          )}
        </Button>
      </Flex>
    </Flex>
  )
}

export default CloudImageBrowserActionsMobile
